module.exports = __webpack_public_path__ + "img/var_01_web.2b9cc974.png";